import { graphql } from 'gatsby'
import React from 'react'

import AgendaItem from '@/components/blocks-library/agenda/agenda-item'

import * as styles from './agenda.module.scss'

interface OpenItem {
  tab: number
  item: number
}
interface CustomProps {
  openItems: OpenItem[]
  handleItemsAcordion: (number) => void
  id: number
}

type AgendaProps = Queries.AgendaFragment & CustomProps

const Agenda: React.FC<AgendaProps> = ({
  items,
  openItems,
  handleItemsAcordion,
  id
}) => {
  const currentTabItems = openItems
    .filter((item) => item.tab === id)
    .map((item) => item.item)
  return (
    <div className={styles.agendaBlock}>
      {
        <div>
          {items?.map((item, index) => {
            if (item === undefined || item === null) return

            return (
              <>
                <div
                  className={`${styles.dropDownTitle} ${currentTabItems.includes(index) && styles.active}`}
                  onClick={() => handleItemsAcordion(index)}
                >
                  <div className="container">
                    <h4>{item.title}</h4>
                  </div>
                </div>
                {currentTabItems.includes(index) && <AgendaItem {...item} />}
              </>
            )
          })}
        </div>
      }
    </div>
  )
}

export default Agenda

export const query = graphql`
  fragment Agenda on DatoCmsAgenda {
    __typename
    id
    title
    items {
      ... on DatoCmsAgendaItem {
        ...AgendaItem
      }
    }
  }
`
